const ROOT_KEY = 'dp';

const toKey = (keys) => `${ROOT_KEY}.${(Array.isArray(keys) ? keys : [keys]).join('.')}`;
const toTyped = (value) => JSON.stringify(value);
const fromTyped = (value) => JSON.parse(value);

export function get(keys) {
  const key = toKey(keys);
  const value = window.localStorage.getItem(key);
  const typed = fromTyped(value);
  return typed;
}
export function set(keys, value) {
  const key = toKey(keys);
  const typed = toTyped(value);
  window.localStorage.setItem(key, typed);
}
export function clear(keys) {
  const key = toKey(keys);
  window.localStorage.removeItem(key);
}
export function reset() {
  window.localStorage.clear();
}
